import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconBing(rest) {
  return (
    <Icon viewBox="0 0 16 16" {...rest}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        transform="translate(3)"
        d="m.01943463.01975309 3.13392332 1.12055348v11.21218213l4.41427629-2.59002075-2.16422551-1.03208296-1.36537559-3.45405116 6.95523766 2.48353659v3.61067258l-7.83812564 4.5949709-3.13571053-1.7728395z"
      />
    </Icon>
  )
}
